export const NOTES = [
  {
    id: 1,
    text: '名前やメールアドレスなどの個人情報を入力しないようご注意ください。'
  },
  {
    id: 2,
    text: '出品者への質問は、利用規約に則ってご利用をお願いします。'
  },
  {
    id: 3,
    text: '送信する前に入力内容をよくご確認の上でご投稿ください。 '
  },
  {
    id: 4,
    text: 'あなたの質問とその回答は他の利用者様にも公開されます。'
  }
];

export const TYPE_FORMAT_TIME = {
  1: 'YEAR',
  2: 'HOUR'
};
